class NavMain {
	constructor() {
		resizeCallbacks.push(this);
		let that = this;
		this.navIsOpened = false;

		/**
		 * Open menu toggle {
		 */
		$('.nav-main__trigger').on('click', function () {
			$('body').addClass('nav-is-opened');
			that.navIsOpened = true;
		});

		$('.nav-main__close').on('click', function () {
			$('body').removeClass('nav-is-opened');
			that.navIsOpened = false;
		});

		/**
		 * Changement du look de la nav au scroll
		 */
		let navScroll = ScrollTrigger.create({
			start: "top -30",
			endTrigger: "html",
			toggleClass: {
				className: 'header-main--scrolled',
				targets: '.header-main'
			}
		});

		const showAnim = gsap.from('.header-main', {
			yPercent: -100,
			paused: true,
			duration: 0.5,
			ease: 'expo.out'
		}).progress(1);

		$(window).on('wheel', function (e) {
			if (!that.navIsOpened) {
				if (e.originalEvent.deltaY > 30) {
					showAnim.reverse();
				} else if (e.originalEvent.deltaY < -30) {
					showAnim.play();
				}
			}
		});


		const pagesWithDarkLogo = document.querySelector('.post-type-archive-news, .page-contact, .single-news');

		const whiteLogo = document.querySelectorAll('.white-logo');
		const darkLogo = document.querySelectorAll('.dark-logo');

		if (pagesWithDarkLogo) {
			whiteLogo.forEach(logo => {
				logo.style.display = 'none';
			});
			darkLogo.forEach(logo => {
				logo.style.display = 'block';
			});
		} else {
			darkLogo.forEach(logo => {
				logo.style.display = 'none';
			});

			whiteLogo.forEach(logo => {
				logo.style.display = 'block';
			});
		}

		this.homePage = document.querySelector('.page-template-template-home');

		if (this.homePage) {
			document.querySelector('.scroll-icon').addEventListener('click', () => {
				document.querySelector('#scrollStart').scrollIntoView({behavior: "smooth"});
				// showAnim.reverse();
			});
		}

		this.hashPage = window.location.hash;
		console.log(this.hashPage);

		if (this.hashPage) {
			let scrollTop = 0;

			window.addEventListener('wheel', (e) => {
				const scrollDetect = window.pageYOffset || document.documentElement.scrollTop;

				if (scrollDetect > scrollTop) {
					showAnim.reverse();
				} else {

				}
				scrollTop = scrollDetect <= 0 ? 0 : scrollDetect;
			});

		}
	}

	resize() {
		this.navIsOpened = false;
		$('body').removeClass('nav-is-opened');
	}
}